var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"heatmap-chart",style:({
    width: _vm.config.chartWidth + 'px',
    height: _vm.config.chartHeight + 'px',
  })},[_c('div',{staticClass:"heatmap-chart-wrapper"},[_c('div',{staticClass:"heatmap-chart-title",style:({
        width: '100%',
        textAlign: _vm.style.titleStyle.align,
        fontSize: _vm.style.titleStyle.fontSize + 'px',
        color: _vm.style.titleStyle.color,
      })},[_vm._v(" "+_vm._s(_vm.config.chartTitle)+" ")]),(_vm.borderImgUrl)?_c('img',{staticClass:"heatmap-chart-border",style:({ display: 'inline-block', width: '100%', height: '100%' }),attrs:{"src":_vm.borderImgUrl,"alt":""}}):_vm._e()]),_c('div',{ref:"heatMap",staticClass:"heatmap-chart-container"})])
}
var staticRenderFns = []

export { render, staticRenderFns }